import React from 'react';

import classnames from 'classnames';

import styles from './Button.scss';

export default class Button extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.clickAction();
  }

  render() {
    const buttonClass = classnames(
      styles.button,
      {
        [styles.pushLeft]: this.props.pushLeft,
        [styles.disabled]: this.props.disabled,
      },
      styles[this.props.type],
      styles[this.props.size],
      this.props.className
    );

    return (
      <a
        type={this.props.type}
        href={this.props.href ? this.props.href : '#'}
        target={this.props.target ? this.props.target : ''}
        className={buttonClass}
        onClick={this.props.disabled ? undefined : this.handleClick}
        style={this.props.style}
      >
        {this.props.children}
      </a>
    );
  }
}

Button.propTypes = {
  /** Button label */
  children: React.PropTypes.oneOfType([React.PropTypes.array, React.PropTypes.string]).isRequired,
  /** Gets called when the user clicks on the button */
  clickAction: React.PropTypes.func,
  disabled: React.PropTypes.bool,
  /** Moves the button as far right as it can go **/
  pushLeft: React.PropTypes.bool,
  /** Choose the type of button **/
  type: React.PropTypes.oneOf(['submit', 'warn', 'action', 'text', 'purchase', 'secondary']),
  /** The size of the button **/
  size: React.PropTypes.oneOf(['small', 'medium', 'large']),
  /** Link address **/
  href: React.PropTypes.string,
  /** Link target **/
  target: React.PropTypes.string,
  /** Extra styles to be passed in **/
  style: React.PropTypes.object,
  /** Extra class names to be passed in **/
  className: React.PropTypes.string,
};

Button.defaultProps = {
  disabled: false,
  pushLeft: false,
  href: '#',
  style: {},
  size: 'small',
};



// WEBPACK FOOTER //
// ./src/components/button/components/Button.jsx